export interface SelectListItem {
  isDisabled: boolean;
  group: string | null;
  isSelected: boolean;
  text: string;
  value: string;
}
